import {
  GET_ALL_ACTIVITIES,
  GET_ALL_TODO_PERFORMANCE_DATA,
  GET_ALL_ASSET,
  GET_ALL_ASSET_ENTRIES,
  GET_ALL_ASSET_DATA,
  GET_ALL_TODO_DATA,
  GET_ALL_TODO_CUSTOM_COMPONENTS,
  GET_ALL_TODO_PERFORMANCE,
  GET_ALL_BOOKING_DETAILS,
  GET_ALL_FILE_NAME,
  GET_ALL_DOCUMENT,
  RESET_TODO_PERFORMANCE,
  GET_ALL_TODO_PERFORMANCE_GROUP,
  SET_ASSET_TYPES,
  GET_BOOKING_GROUPS,
  RESET_TODO_CHAT,
  GET_ALL_BOOKING_FILE_UPLOAD,
  DOWNLOAD_TODO_PERFORMANCE_DOCUMENTS,
  SET_USER_LIST,
  RESET_BOOKING_GROUPS,
  SET_THREAD_COUNTER,
  GET_SCAC_DATA,
  GET_BOOKING_REFERENCE_DATA,
  PERFORMANCE_LOADER,
  GET_PERFORMANCE_INVENTORY_DATA,
  SET_ASSET_DATA_FOR_TRACKING
} from "../constants";

const initState = {
  activities: [],
  performancedata: {},
  assetlist: [],
  assetentries: [],
  assetdata: [],
  tododata: [],
  todocomponentdata: [],
  todoperformance: [],
  bookingdetails: [],
  filename: [],
  documents: [],
  tempdata: [],
  asset_entries: [],
  assetEntryData: [],
  performancegroup: {},
  message: [],
  subGroup: [],
  bookingFileUpload: [],
  download_todo_performance_documents: '',
  userList: {},
  threadCounter: 0,
  scacData: [],
  bookingReferenceList: [],
  performanceLoader: false,
  performanceInventoryData: null,
  previous_path: null,
  assetDataForTracking: []
};

const todoPerformance = (state = initState, action) => {
  const { type, payload } = action;

  switch (type) {

    case GET_ALL_ACTIVITIES: {
      return {
        ...state,
        activities: payload,
      };
    }
    case GET_ALL_TODO_PERFORMANCE_DATA: {
      return {
        ...state,
        performancedata: payload,
        tempdata: payload.asset_entries,
      };
    }
    case GET_ALL_ASSET: {
      return {
        ...state,
        assetlist: payload,
      };
    }
    case GET_ALL_ASSET_ENTRIES: {
      return {
        ...state,
        asset_entries: payload,
      };
    }
    case GET_ALL_ASSET_DATA: {
      return {
        ...state,
        assetdata: payload,
      };
    }
    case GET_ALL_TODO_DATA: {
      return {
        ...state,
        tododata: payload,
      };
    }
    case GET_ALL_TODO_CUSTOM_COMPONENTS: {
      return {
        ...state,
        todocomponentdata: payload,
      };
    }
    case GET_ALL_TODO_PERFORMANCE: {
      return {
        ...state,
        todoperformance: payload,
      };
    }
    case GET_ALL_BOOKING_DETAILS: {
      return {
        ...state,
        bookingdetails: payload,
      };
    }
    case GET_ALL_FILE_NAME: {
      return {
        ...state,
        filename: payload,
      };
    }
    case GET_ALL_DOCUMENT: {
      return {
        ...state,
        documents: payload,
      };
    }
    case GET_ALL_TODO_PERFORMANCE_GROUP: {
      return {
        ...state,
        performancegroup: payload,
      };
    }
    case SET_ASSET_TYPES: {
      return {
        ...state,
        tempdata: payload,
      };
    }

    case GET_ALL_BOOKING_FILE_UPLOAD: {
      return {
        ...state,
        bookingFileUpload: payload,
      };
    }

    case GET_BOOKING_GROUPS: {
      return {
        ...state,
        subGroup: payload,
      };
    }

    case RESET_BOOKING_GROUPS: {
      return {
        ...state,
        subGroup: [],
      };
    }

    case SET_THREAD_COUNTER: {
      return {
        ...state,
        threadCounter: payload
      }
    }

    case RESET_TODO_CHAT: {
      return {
        ...state,
        message: [],
        mainGroup: {},
        subGroup: [],
      };
    }

    case DOWNLOAD_TODO_PERFORMANCE_DOCUMENTS: {
      return {
        ...state,
        download_todo_performance_documents: payload
      }
    }

    case SET_USER_LIST: {
      return {
        ...state,
        userList: payload
      }
    }

    case GET_SCAC_DATA: {
      return {
        ...state,
        scacData: payload
      }
    }

    case GET_BOOKING_REFERENCE_DATA: {
      return {
        ...state,
        bookingReferenceList: payload
      }
    }

    case PERFORMANCE_LOADER: {
      return {
        ...state,
        performanceLoader: payload
      }
    }

    case GET_PERFORMANCE_INVENTORY_DATA: {
      return {
        ...state,
        performanceInventoryData : payload
      }
    }

    case RESET_TODO_PERFORMANCE: {
      return initState;
    }

    case SET_ASSET_DATA_FOR_TRACKING: {
      return {
        ...state,
        assetDataForTracking: payload
      }
    }

    default:
      return state;
  }
};

export default todoPerformance;
